AngularApp = require('resources/assets/coffee/Core/AngularApplication').AngularApplication

class exports.TestApp extends AngularApp
    options: {
        useMap: false
        useSidebar: true
        useNavResize: true
    }

    constructor: () ->
        window.App = this
        super()
        @load 'core::globals/modules'


    mockService: (methods = {}) ->
        sd = @load('core::Testing/ServiceDummy')

        dummy = sd.mockService()

        for k, v of methods
            dummy[k] = v

        return dummy


    mock: (file, overrides) ->
        newobject = {}

        inject ($q) =>
            # Method so we can do fake promises
            newobject._query = (result) ->
                defer = $q.defer()
                defer.resolve result
                return defer.promise

            for name, item of overrides
                if $.isFunction(item)
                    item = item.bind(newobject)()
                    newobject[name] = sinon.stub().returns(item)
                else
                    newobject[name] = $.extend(true, {}, item)

            cls = @loadClass file
            okeys = _.keys(overrides)
            for name, item of cls.prototype when name not in okeys
                newobject[name] = sinon.spy() if $.isFunction(item)


        newobject
